<template>
    <div>
        <div v-for="(row, index) in rows" :key="index" class="flex flex-wrap w-full">
            <div class="flex flex-wrap w-full">
                <div class="lg:w-1/2">
                    <text-input v-model="row.name" :error="row.errors?.name"
                                class="pb-8 pr-6 w-full lg:w-full" label="Student Name"
                    />
                    <text-input v-model="row.class" :error="row.errors?.class"
                                class="pb-8 pr-6 w-full lg:w-full" label="Class"
                    />
                    <text-input v-model="row.school_name" :error="row.errors?.school_name"
                                class="pb-8 pr-6 w-full lg:w-full" label="School Name"
                    />
                </div>
                <div class="lg:w-1/2">
                    <!-- Student Photo Upload Section -->
                    <div class="pb-8 pr-6 w-full lg:w-1/2">
                        <h3 class="font-bold mb-4">Student's Photo</h3>
                        <file-pond
                            type="file"
                            :name="`photo_${index}`"
                            :files="getPreloadedFile('student_'+index)"
                            @change="handlePhotoChange($event, index)"
                            @removefile="handleRemoveFile($event,'student_'+index)"
                            class="form-input w-full photo-preview"
                            accept="image/*"
                        />
                        <div v-if="row.photo" class="mt-4 photo-container">
                            <img :src="row.photo" alt="Student's Photo" class="w-1/2 photo-preview"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full flex justify-center mb-6">
            <button @click.prevent="removeChildren(index)" class="btn btn-danger mr-2" v-if="rows.length > 1">
                Remove Student
            </button>
            <button @click.prevent="addChildren" class="btn btn-primary">Add Student</button>
        </div>

    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import {Link} from '@inertiajs/vue3'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import TextInput from '@/Shared/TextInput'

// Register the FilePond component globally
const FilePond = vueFilePond()

export default {
    name: 'student-info',
    props: {
        modelValue: {
            type: Array,
            required: true,
            default: () => [], // Empty array by default
        },
        title: {
            type: String,
            default: 'Student Info',
        },
        getPreloadedFile: {
            type: Function,
            required: true, // Expect the function to be passed from the parent
        },
    },
    components: {Icon, Link, FilePond, TextInput},
    emits: ['update:modelValue', 'removeFile'], // Emit when modelValue changes
    data() {
        return {
            photos: {},
            studentFiles: [],
        }
    },
    computed: {
        rows: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value) // Emit the updated value back to the parent
            },
        },
    },
    methods: {
        addChildren() {
            this.rows.push({
                name: '',
                class: '',
                photo: null,
                school_name: '',
            })
        },
        removeChildren(index) {
            console.log('removeChildren index ' + index)
            if (this.rows.length > 1) {
                // this.rows.splice(this.rows.length, 1)
                this.rows.pop()
            }
        },
        handlePhotoChange(event, index) {
            console.log('photo change ' + index)
            this.$emit('studentChange', event, 'student_' + index)
        },
        handleRemoveFile(event, name) {
            console.log("FilePond remove event:", event);
            this.$emit('removeXFile', event, name)
        },

    },
}
</script>
